import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hook";
import { setSearchInProgress, setSortBy, setUserSelectedCreator } from "./userInterractionsSlice";
export default function useUserInteractions() {
    const dispatch = useAppDispatch();
    const isSearchInProgress = useAppSelector((state) => state?.userInteractions?.isSearchInProgress);
    const sortBy = useAppSelector((state) => state?.userInteractions?.sortBy);
    const selectedCreator = useAppSelector((state) => state?.userInteractions?.selectedCreator);
    // The following functions are wrappers around the dispatch functions
    const setIsSearchInProgress = useCallback((payload) => {
        dispatch(setSearchInProgress(payload));
    }, [setSearchInProgress]);
    const setUserSortBy = useCallback((payload) => {
        dispatch(setSortBy(payload));
    }, [setSortBy]);
    const setSelectedCreator = useCallback((payload) => {
        dispatch(setUserSelectedCreator(payload));
    }, [setUserSelectedCreator]);
    return {
        sortBy,
        selectedCreator,
        isSearchInProgress,
        setUserSortBy,
        setSelectedCreator,
        setIsSearchInProgress,
    };
}
